import styled from "styled-components";

export const TagContainer = styled.span`
  .saleChannelStatusTag {
    width: 120px;
    justify-content: center;
    text-align: center;
    display: inline-flex;
    height: 32px;
    border-radius: 300px;
    font-weight: 600;
    font-size: 14px;
    align-content: center;
    align-items: center;
    padding: 0 12px;
  }
`;
